/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
// import { useRouter } from 'next/router';
import Spinner from '../icons/spinner';
import NoDataFound from '../components/shared/NoDataFound';

function CourseInfiniteScroll({
  pageStateValue,
  PageState,
  data,
  fetchMore,
  noDatamsg,
  loading,
  hasNextPage,
  renderComponent,
  searchKey,
}) {
//   const router = useRouter();
  const [items, setItems] = useState([]);
  const bottomRef = useRef(null);
  const observer = useRef(null);
  const [isFetchingMore, setIsFetchingMore] = useState(false);

  // Handle data updates
  useEffect(() => {
    if (data && data.length > 0) {
      setItems((prevItems) => {
        if (pageStateValue === 1) {
          // first page, replace all data
          return [...data];
        }
        // Otherwise new data without duplicates
        const existingIds = new Set(prevItems.map((item) => item.id));
        const newData = data.filter((item) => !existingIds.has(item.id));
        return [...prevItems, ...newData];
      });
    } else if (pageStateValue === 1 && data && data.length === 0) {
      setItems([]);
    }
  }, [data, pageStateValue]);

  // Handle loading more data when pageState changes
  useEffect(() => {
    if (pageStateValue > 1 && hasNextPage && fetchMore) {
      setIsFetchingMore(true);
      fetchMore({
        variables: {
          page: pageStateValue,
          limit: 12,
        },
      }).finally(() => {
        setIsFetchingMore(false);
      });
    }
  }, [pageStateValue, fetchMore, hasNextPage]);

  // Reset data when selectedTag, searchKey, or other filters change
  //   useEffect(() => {
  //     setItems([]);
  //     PageState(1);
  //   }, [selectedTag, searchKey, selectTestTab, PageState]);

  // Intersection Observer for infinite scroll
  useEffect(() => {
    if (bottomRef.current) {
      observer.current = new IntersectionObserver(
        (entries) => {
          const [entry] = entries;
          if (entry.isIntersecting && !loading && !isFetchingMore && hasNextPage && !searchKey) {
            PageState((prevPage) => prevPage + 1);
          }
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 1.0,
        },
      );
      observer.current.observe(bottomRef.current);
    }

    return () => {
      if (observer.current && bottomRef.current) {
        observer.current.unobserve(bottomRef.current);
      }
    };
  }, [loading, isFetchingMore, hasNextPage, PageState]);

  const noMoreData = !hasNextPage;

  return (
    <div>
      {loading && items.length === 0 && !isFetchingMore ? (
        <Spinner fullPage />
      ) : (
        <div>
          {items.length > 0 ? (
            <>
              {/* Render the component with items */}
              {renderComponent ? renderComponent(items) : null}

              {/* Loading indicator for fetching more */}
              {isFetchingMore && !noMoreData && (
                <div className="text-center flex justify-center items-center p-6">
                  <Spinner color="text-customBlue" />
                </div>
              )}
            </>
          ) : (
            <NoDataFound noMsg={noDatamsg} />
          )}
        </div>
      )}

      <div ref={bottomRef} style={{ height: '1px' }} />
    </div>
  );
}

CourseInfiniteScroll.propTypes = {
  data: PropTypes.array,
  fetchMore: PropTypes.func,
  hasNextPage: PropTypes.bool,
  loading: PropTypes.bool,
  pageStateValue: PropTypes.number.isRequired,
  PageState: PropTypes.func.isRequired,
  noDatamsg: PropTypes.string,
  renderComponent: PropTypes.func.isRequired,
  searchKey: PropTypes.string,
};

export default CourseInfiniteScroll;
